import React from 'react';
import { 
  FaHeart, 
  FaChartLine, 
  FaUsers,
  FaExternalLinkAlt,
  FaBullseye,
  FaCheckCircle,
  FaHandHoldingHeart
} from 'react-icons/fa';
import { categories } from '../data/categories';
import { useNavigate } from 'react-router-dom';
import '../styles/CauseDetail.css';
import { GiThreeFriends } from "react-icons/gi";

const CauseDetail = ({ cause, onClose }) => {
  const navigate = useNavigate();

  const categoryDetails = cause.categories ? cause.categories.map(categoryId => {
    const category = categories.find(c => c.id === categoryId);
    return category ? {
      name: category.name,
      icon: category.icon
    } : null;
  }).filter(Boolean) : [];

  return (
    <div className="cause-detail-overlay">
      <div className="cause-detail-container">
        <button className="close-button" onClick={onClose}>&times;</button>
        
        <div className="cause-header">
          <img src={cause.image} alt="" className="cause-bg-image" />
          <div className="cause-logo">{cause.icon}</div>
          <h2>{cause.name}</h2>
          <p className="cause-location">{cause.state}</p>
        </div>

        <div className="cause-categories">
          {categoryDetails.map((category, index) => (
            <div key={index} className="category-tag-wrapper">
              <span className="cause-category-tag">
                {category.icon}
                {category.name}
              </span>
            </div>
          ))}
        </div>

        <div className="cause-stats">
          <div className="stat-item">
            <FaHeart className="stat-icon" />
            <div className="stat-info">
              <div className="stat-value">${cause.fundsRaised.toLocaleString()}</div>
              <div className="stat-label">Raised</div>
            </div>
          </div>
          <div className="stat-item">
            <FaUsers className="stat-icon" />
            <div className="stat-info">
              <div className="stat-value">{cause.supporters}</div>
              <div className="stat-label">Supporters</div>
            </div>
          </div>
          <div className="stat-item">
            <FaChartLine className="stat-icon" />
            <div className="stat-info">
              <div className="stat-value">{cause.projectsCompleted}</div>
              <div className="stat-label">Projects</div>
            </div>
          </div>
        </div>

        <div className="cause-description">
          <p>{cause.description}</p>
        </div>

        {/* Impact Tiers Section */}
        <div className="impact-tiers-section">
          <div className="section-header">
            <FaHandHoldingHeart className="section-icon" />
            <h3>Impact Tiers</h3>
          </div>
          {cause.impactTiers.map((tier, index) => (
            <div key={index} className="impact-tier-card">
              <div className="tier-header">
                <h4>${tier.level.toLocaleString()}</h4>
                <span className="tier-label">Funding Goal</span>
              </div>
              <div className="tier-content">
                <p className="tier-impact">{tier.impact}</p>
                <p className="tier-allocation">{tier.allocation}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Fallback Partners Section */}
        <div className="fallback-partners-section">
          <div className="section-header">
            <GiThreeFriends className="partners-section-icon" />
            <h3>Trusted Partners</h3>
          </div>
          <div className="partners-list">
            {cause.fallbackPartners.map((partner, index) => (
              <div key={index} className="partner-item">
                <FaCheckCircle className="partner-icon" />
                <span>{partner}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="cause-actions">
          <button 
            className="donate-button"
            onClick={() => navigate(`/donate/${cause.id}`)}
          >
            Support this Cause
          </button>
          <button 
            className="learn-more-button"
            onClick={() => window.open(cause.website, '_blank', 'noopener,noreferrer')}
          >
            Learn More <FaExternalLinkAlt size={12} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CauseDetail; 